<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import VueApexCharts from 'vue-apexcharts';
import {jsPDF} from 'jspdf'; 
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Swal from '@/utils/ugm-swal';
import pdf from 'vue-pdf';

export default {
    components: { Layout, PageHeader, DatePicker, pdf, apexchart: VueApexCharts },
    data() {
        return {
            title: "Historial de Gastos",
            items: [
                {
                text: "Gastos",
                href: "/web/reembolsos/ver_reembolsos"
                },
                {
                text: "Historial de Gastos",
                active: true
                }
            ],
            reembolsos:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            direccion:'',
            desde:'',
            hasta:'',
            extension:'',
            isLoading: false,
            hasLoaded: false,
            dashboard: {
                total_monto: 0,
                cantidad_gastos: 0,
                cantidad_eventos: 0,
                promedio_gasto: 0,
                promedio_evento: 0,
                por_categoria: [],
                por_evento: [],
                por_fecha: [],
                por_coordinador: [],
            },
        };
    },
    computed:{
        rows() {
            return this.filteredData.length;
        },
        filteredData() {
            const filtro = (this.filtro || '').toLowerCase().trim();
            if (!filtro) {
                return this.reembolsos;
            }

            // Filtramos los datos en base al campo 'filtro'
            return this.reembolsos.filter((item) => {
                const codigo = (item.codigo || '').toLowerCase();
                const coordinador = (item.coordinador_evento || '').toLowerCase();
                return (
                    codigo.includes(filtro) ||
                    coordinador.includes(filtro)
                );
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
        chartCategorias() {
            const datos = this.dashboard.por_categoria || [];
            return {
                series: datos.map(item => Number(item.total_monto) || 0),
                options: {
                    chart: { type: 'donut', fontFamily: 'inherit' },
                    labels: datos.map(item => item.categoria || 'Sin categoría'),
                    colors: ['#252C5F', '#61B7E4', '#CB9700', '#27ae60', '#8e44ad', '#e67e22', '#16a085', '#95a5a6'],
                    legend: { position: 'bottom', fontSize: '11px' },
                    dataLabels: { enabled: true, style: { fontSize: '11px' } },
                    plotOptions: { pie: { donut: { size: '58%' } } },
                    tooltip: { y: { formatter: value => this.formatMonto(value) } },
                },
            };
        },
        chartEvolucion() {
            const datos = this.dashboard.por_fecha || [];
            return {
                series: [{ name: 'Gasto', data: datos.map(item => Number(item.total_monto) || 0) }],
                options: {
                    chart: { type: 'area', toolbar: { show: false }, fontFamily: 'inherit' },
                    colors: ['#252C5F'],
                    fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0.05 } },
                    stroke: { curve: 'smooth', width: 2 },
                    xaxis: {
                        categories: datos.map(item => this.formatoFechaGrafico(item.fecha)),
                        labels: { style: { fontSize: '10px' }, rotate: -45 },
                    },
                    yaxis: {
                        labels: {
                            formatter: value => this.formatMonto(value),
                            style: { fontSize: '10px' },
                        },
                    },
                    dataLabels: { enabled: false },
                    grid: { borderColor: '#f0f2fa' },
                    tooltip: { y: { formatter: value => this.formatMonto(value) } },
                },
            };
        },
        chartEventos() {
            const datos = (this.dashboard.por_evento || []).slice(0, 10).reverse();
            return {
                series: [{ name: 'Gasto', data: datos.map(item => Number(item.total_monto) || 0) }],
                options: {
                    chart: { type: 'bar', toolbar: { show: false }, fontFamily: 'inherit' },
                    colors: ['#61B7E4'],
                    plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: '62%' } },
                    xaxis: {
                        categories: datos.map(item => item.codigo || 'Sin código'),
                        labels: { formatter: value => this.formatMonto(value), style: { fontSize: '10px' } },
                    },
                    yaxis: { labels: { style: { fontSize: '10px' } } },
                    dataLabels: { enabled: false },
                    grid: { borderColor: '#f0f2fa' },
                    tooltip: { y: { formatter: value => this.formatMonto(value) } },
                },
            };
        },
        chartCoordinadores() {
            const datos = (this.dashboard.por_coordinador || []).slice(0, 10).reverse();
            return {
                series: [{ name: 'Gasto', data: datos.map(item => Number(item.total_monto) || 0) }],
                options: {
                    chart: { type: 'bar', toolbar: { show: false }, fontFamily: 'inherit' },
                    colors: ['#CB9700'],
                    plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: '62%' } },
                    xaxis: {
                        categories: datos.map(item => item.coordinador || 'Sin coordinador'),
                        labels: { formatter: value => this.formatMonto(value), style: { fontSize: '10px' } },
                    },
                    yaxis: { labels: { style: { fontSize: '10px' } } },
                    dataLabels: { enabled: false },
                    grid: { borderColor: '#f0f2fa' },
                    tooltip: { y: { formatter: value => this.formatMonto(value) } },
                },
            };
        },
    },
    methods:{
        ver_mas(item){
            this.$set(item, 'boton', item.boton === 'Ver más' ? 'Ver menos' : 'Ver más');
        },
        ver_comprobante(item){
            if (item.imagen_url) {
                const extension = item.imagen_url.split('.').pop().toLowerCase();
                if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
                    this.direccion = item.imagen_url;
                    this.extension = '';
                } else if (extension === 'pdf') {
                    this.direccion = item.imagen_url;
                    this.extension = 'pdf';
                }
            }
            this.$refs['modal-imagen'].show();
        },
        async generarPDF(item1, item2) {
            const doc = new jsPDF();
            // Agregar título
            doc.setFont("helvetica", "bold");
            doc.setFontSize(20);
            doc.text("Evento: " + item1.codigo, 20, 20);
            doc.text("Fecha: " + item2.fecha, 20, 40);
            doc.text("Monto: " + item2.monto, 20, 60);
            // Agregar imagen si está disponible
            if (item2.imagen_url) {
                try {
                    const extension = item2.imagen_url.split('.').pop().toLowerCase();

                    if (extension === "png" || extension === "jpg" || extension === "jpeg") {
                        // Si es una imagen
                        const base64 = await this.convertirImagenABase64(item2.imagen_url);
                        doc.addImage(base64, "PNG", 20, 80, 100, 100); // Posición y tamaño
                    } else if (extension === "pdf") {
                        // Si es un PDF, cargarlo dentro del PDF generado
                        const response = await fetch(item2.imagen_url);
                        const blob = await response.blob();
                        const pdfUrl = URL.createObjectURL(blob);

                        const pdfDoc = await pdfjsLib.getDocument(pdfUrl).promise;
                        const page = await pdfDoc.getPage(1);
                        const viewport = page.getViewport({ scale: 1 });

                        const canvas = document.createElement("canvas");
                        const context = canvas.getContext("2d");
                        canvas.width = viewport.width;
                        canvas.height = viewport.height;

                        await page.render({ canvasContext: context, viewport }).promise;

                        const pdfImage = canvas.toDataURL("image/png");
                        doc.addImage(pdfImage, "PNG", 20, 80, 150, 200);
                    }
                } catch (error) {
                    console.error("Error al cargar la imagen o PDF:", error);
                }
            }
            // Descargar el PDF
            doc.save("documento.pdf");
            // Agregar fecha de descarga del documento
            try {
                await axios.get(`/api/descarga_gasto/${item2.id}`);
                this.mostrarmes();
            } catch (error) {
                console.error("Error al registrar la descarga:", error);
            }
        },
        obtenerRangoFechas() {
            const hoy = new Date();
            const diaHoy = hoy.getDate();
            const mesHoy = hoy.getMonth();
            const anioHoy = hoy.getFullYear();
            let fechaInicio, fechaFin;
            if (diaHoy <= 25) {
                // Si hoy es menor o igual a 25, el rango es del 26 del mes anterior al 25 de este mes
                const mesAnterior = mesHoy === 0 ? 11 : mesHoy - 1;
                const anioInicio = mesHoy === 0 ? anioHoy - 1 : anioHoy;
                fechaInicio = new Date(anioInicio, mesAnterior, 26);
                fechaFin = new Date(anioHoy, mesHoy, 25);
            } else {
                // Si hoy es mayor a 25, el rango es del 26 de este mes al 25 del mes siguiente
                const mesSiguiente = mesHoy === 11 ? 0 : mesHoy + 1;
                const anioFin = mesHoy === 11 ? anioHoy + 1 : anioHoy;
                fechaInicio = new Date(anioHoy, mesHoy, 26);
                fechaFin = new Date(anioFin, mesSiguiente, 25);
            }
            this.desde = moment(fechaInicio).format('YYYY-MM-DD');
            this.hasta = moment(fechaFin).format('YYYY-MM-DD');
            //return { fechaInicio, fechaFin };
        },
        dashboardVacio() {
            return {
                total_monto: 0,
                cantidad_gastos: 0,
                cantidad_eventos: 0,
                promedio_gasto: 0,
                promedio_evento: 0,
                por_categoria: [],
                por_evento: [],
                por_fecha: [],
                por_coordinador: [],
            };
        },
        mostrarmes(){
            if (!this.desde || !this.hasta || moment(this.desde).isAfter(moment(this.hasta), 'day')) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Rango de fechas inválido',
                    text: 'La fecha Desde debe ser anterior o igual a la fecha Hasta.',
                    showConfirmButton: false,
                    timer: 3000,
                });
                return;
            }

            this.isLoading = true;
            axios.get('/api/gastos_historial/'+this.desde+'/'+this.hasta).then(response => {
                this.reembolsos = (response.data.reembolsos || []).filter((us) => us.boolean == true);
                this.dashboard = response.data.gastos_dashboard || this.dashboardVacio();
                this.currentPage = 1;
                this.hasLoaded = true;
            }).catch(() => {
                this.reembolsos = [];
                this.dashboard = this.dashboardVacio();
                this.hasLoaded = true;
                Swal.fire({
                    icon: 'error',
                    title: 'No se pudo cargar el historial',
                    showConfirmButton: false,
                    timer: 3000,
                });
            }).finally(() => {
                this.isLoading = false;
            });
        },
        formatFecha(fechahora){
            if (!fechahora) {
                return '—';
            }
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
        formatoFechaGrafico(fecha){
            return fecha ? moment(fecha).format('DD-MM') : '';
        },
        formatMonto(valor){
            return new Intl.NumberFormat('es-CL', {
                style: 'currency',
                currency: 'CLP',
                maximumFractionDigits: 0,
            }).format(Number(valor) || 0);
        },
        async generarPDFtodos() {
            const doc = new jsPDF();
            doc.setFont("helvetica", "bold");
            let primeraPagina = true; // Variable para manejar la primera página
            for (const evento of this.filteredData) {
                for (let index = 0; index < evento.gastos.length; index++) {
                    const gasto = evento.gastos[index];
                    // Agregar nueva página si no es la primera iteración
                    if (!primeraPagina) {
                        doc.addPage();
                    }
                    primeraPagina = false; // Después de la primera iteración, siempre se agregará una página
                    doc.setFontSize(20);
                    doc.text("Evento: " + evento.codigo, 20, 20);
                    doc.text("Fecha: " + gasto.fecha, 20, 40);
                    doc.text("Monto: " + gasto.monto, 20, 60);
                    if (gasto.imagen_url) {
                        try {
                            const extension = gasto.imagen_url.split('.').pop().toLowerCase();

                            if (extension === "png" || extension === "jpg" || extension === "jpeg") {
                                // Si es una imagen
                                const base64 = await this.convertirImagenABase64(gasto.imagen_url);
                                doc.addImage(base64, "PNG", 20, 80, 100, 100); // Posición y tamaño
                            } else if (extension === "pdf") {
                                // Si es un PDF, cargarlo dentro del PDF generado
                                const response = await fetch(gasto.imagen_url);
                                const blob = await response.blob();
                                const pdfUrl = URL.createObjectURL(blob);

                                const pdfDoc = await pdfjsLib.getDocument(pdfUrl).promise;
                                const page = await pdfDoc.getPage(1);
                                const viewport = page.getViewport({ scale: 1 });

                                const canvas = document.createElement("canvas");
                                const context = canvas.getContext("2d");
                                canvas.width = viewport.width;
                                canvas.height = viewport.height;

                                await page.render({ canvasContext: context, viewport }).promise;

                                const pdfImage = canvas.toDataURL("image/png");
                                doc.addImage(pdfImage, "PNG", 20, 80, 150, 200);
                            }
                        } catch (error) {
                            console.error("Error al cargar la imagen o PDF:", error);
                        }
                    }
                }
            }
            // Descargar el PDF
            doc.save("documento.pdf");
            // Registrar descargas para cada gasto
            for (const evento of this.filteredData) {
                for (const gasto of evento.gastos) {
                    try {
                        await axios.get('/api/descarga_gasto/' + gasto.id);
                    } catch (error) {
                        console.error("Error al registrar la descarga:", error);
                    }
                }
            }
            this.mostrarmes();
        },
        convertirImagenABase64(url) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = "Anonymous";
                img.src = url;
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    const base64 = canvas.toDataURL("image/png");
                    resolve(base64);
                };
                img.onerror = () => reject(new Error("No se pudo cargar la imagen"));
            });
        }
    },
    created(){
        this.obtenerRangoFechas();
        this.mostrarmes();
        /*axios.get('/api/get_gastos').then(res=>{
            this.reembolsos=res.data.eventos;
        });*/
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <!-- Filtro de fechas -->
            <div class="col-12">
                <div class="card">
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-history font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Historial de Gastos</h5>
                            <small class="text-white" style="opacity:.8;">Revisa el historial de gastos por período</small>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row align-items-end">
                            <div class="col-md-4">
                                <label class="font-weight-semibold mb-1" style="color:#252C5F;">Desde</label>
                                <date-picker v-model="desde" value-type="YYYY-MM-DD" format="DD-MM-YYYY"
                                    :first-day-of-week="2" lang="es" style="width:100%;"></date-picker>
                            </div>
                            <div class="col-md-4">
                                <label class="font-weight-semibold mb-1" style="color:#252C5F;">Hasta</label>
                                <date-picker v-model="hasta" value-type="YYYY-MM-DD" format="DD-MM-YYYY"
                                    :first-day-of-week="2" lang="es" style="width:100%;"></date-picker>
                            </div>
                            <div class="col-md-2">
                                <button class="btn-ugm-dark w-100" @click="mostrarmes">
                                    <i class="bx bx-search mr-1"></i> Ver
                                </button>
                            </div>
                            <div class="col-md-2 text-right">
                                <button class="btn-ugm-gold w-100" @click="generarPDFtodos"
                                    v-b-popover.hover="'Descarga todos los comprobantes no descargados'" title="Descarga de comprobantes">
                                    <i class="bx bx-download mr-1"></i> PDF
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Dashboard del período -->
            <div class="col-12" v-if="hasLoaded && !isLoading && dashboard.cantidad_gastos > 0">
                <div class="row mb-3">
                    <div class="col-sm-6 col-xl mb-3">
                        <div class="card shadow-sm h-100 dashboard-kpi" style="border-left-color:#252C5F;">
                            <div class="card-body py-3 px-4 d-flex align-items-center justify-content-between">
                                <div>
                                    <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Total gastado</p>
                                    <h3 class="mb-0 font-weight-bold" style="color:#252C5F;">{{ formatMonto(dashboard.total_monto) }}</h3>
                                    <small class="text-muted">Todos los gastos del período</small>
                                </div>
                                <div class="dashboard-kpi-icon" style="background:rgba(37,44,95,.1);color:#252C5F;">
                                    <i class="bx bx-wallet font-size-22"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-xl mb-3">
                        <div class="card shadow-sm h-100 dashboard-kpi" style="border-left-color:#61B7E4;">
                            <div class="card-body py-3 px-4 d-flex align-items-center justify-content-between">
                                <div>
                                    <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Cantidad de gastos</p>
                                    <h3 class="mb-0 font-weight-bold" style="color:#252C5F;">{{ dashboard.cantidad_gastos }}</h3>
                                    <small class="text-muted">Comprobantes registrados</small>
                                </div>
                                <div class="dashboard-kpi-icon" style="background:rgba(97,183,228,.14);color:#1a6fa8;">
                                    <i class="bx bx-receipt font-size-22"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-xl mb-3">
                        <div class="card shadow-sm h-100 dashboard-kpi" style="border-left-color:#CB9700;">
                            <div class="card-body py-3 px-4 d-flex align-items-center justify-content-between">
                                <div>
                                    <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Eventos con gastos</p>
                                    <h3 class="mb-0 font-weight-bold" style="color:#252C5F;">{{ dashboard.cantidad_eventos }}</h3>
                                    <small class="text-muted">Actividades del período</small>
                                </div>
                                <div class="dashboard-kpi-icon" style="background:rgba(203,151,0,.14);color:#CB9700;">
                                    <i class="bx bx-calendar-event font-size-22"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-xl mb-3">
                        <div class="card shadow-sm h-100 dashboard-kpi" style="border-left-color:#27ae60;">
                            <div class="card-body py-3 px-4 d-flex align-items-center justify-content-between">
                                <div>
                                    <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Promedio por gasto</p>
                                    <h3 class="mb-0 font-weight-bold" style="color:#252C5F;">{{ formatMonto(dashboard.promedio_gasto) }}</h3>
                                    <small class="text-muted">Monto promedio</small>
                                </div>
                                <div class="dashboard-kpi-icon" style="background:rgba(39,174,96,.12);color:#27ae60;">
                                    <i class="bx bx-trending-up font-size-22"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-xl mb-3">
                        <div class="card shadow-sm h-100 dashboard-kpi" style="border-left-color:#8e44ad;">
                            <div class="card-body py-3 px-4 d-flex align-items-center justify-content-between">
                                <div>
                                    <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Promedio por evento</p>
                                    <h3 class="mb-0 font-weight-bold" style="color:#252C5F;">{{ formatMonto(dashboard.promedio_evento) }}</h3>
                                    <small class="text-muted">Gasto promedio por actividad</small>
                                </div>
                                <div class="dashboard-kpi-icon" style="background:rgba(142,68,173,.12);color:#8e44ad;">
                                    <i class="bx bx-bar-chart-alt-2 font-size-22"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Gráficos 1 y 2 -->
                <div class="row mb-3">
                    <div class="col-lg-5 mb-3">
                        <div class="card shadow-sm h-100">
                            <div class="card-header dashboard-card-header">
                                <i class="bx bx-doughnut-chart font-size-20 mr-2"></i>
                                <div>
                                    <h6 class="mb-0 font-weight-bold">Gasto por categoría</h6>
                                    <small>Distribución del monto total</small>
                                </div>
                            </div>
                            <div class="card-body pt-2">
                                <apexchart v-if="dashboard.por_categoria.length" type="donut" height="280"
                                    :options="chartCategorias.options" :series="chartCategorias.series">
                                </apexchart>
                                <div v-else class="text-center py-4 text-muted">Sin datos por categoría</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-7 mb-3">
                        <div class="card shadow-sm h-100">
                            <div class="card-header dashboard-card-header">
                                <i class="bx bx-line-chart font-size-20 mr-2"></i>
                                <div>
                                    <h6 class="mb-0 font-weight-bold">Evolución del gasto</h6>
                                    <small>Monto por fecha del comprobante</small>
                                </div>
                            </div>
                            <div class="card-body pt-2">
                                <apexchart v-if="dashboard.por_fecha.length" type="area" height="280"
                                    :options="chartEvolucion.options" :series="chartEvolucion.series">
                                </apexchart>
                                <div v-else class="text-center py-4 text-muted">Sin fechas disponibles</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Gráficos 3 y 4 -->
                <div class="row mb-3">
                    <div class="col-lg-6 mb-3">
                        <div class="card shadow-sm h-100">
                            <div class="card-header dashboard-card-header">
                                <i class="bx bx-bar-chart-alt-2 font-size-20 mr-2"></i>
                                <div>
                                    <h6 class="mb-0 font-weight-bold">Gasto por evento</h6>
                                    <small>Top 10 eventos por monto</small>
                                </div>
                            </div>
                            <div class="card-body pt-2">
                                <apexchart v-if="dashboard.por_evento.length" type="bar" height="280"
                                    :options="chartEventos.options" :series="chartEventos.series">
                                </apexchart>
                                <div v-else class="text-center py-4 text-muted">Sin datos por evento</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-3">
                        <div class="card shadow-sm h-100">
                            <div class="card-header dashboard-card-header">
                                <i class="bx bx-user-voice font-size-20 mr-2"></i>
                                <div>
                                    <h6 class="mb-0 font-weight-bold">Gasto por coordinador</h6>
                                    <small>Top 10 coordinadores por monto</small>
                                </div>
                            </div>
                            <div class="card-body pt-2">
                                <apexchart v-if="dashboard.por_coordinador.length" type="bar" height="280"
                                    :options="chartCoordinadores.options" :series="chartCoordinadores.series">
                                </apexchart>
                                <div v-else class="text-center py-4 text-muted">Sin datos por coordinador</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Tablas resumen -->
                <div class="row mb-4">
                    <div class="col-lg-5 mb-3">
                        <div class="card shadow-sm h-100">
                            <div class="card-header dashboard-card-header">
                                <i class="bx bx-list-ul font-size-20 mr-2"></i>
                                <div>
                                    <h6 class="mb-0 font-weight-bold">Resumen por categoría</h6>
                                    <small>Detalle del monto y cantidad</small>
                                </div>
                            </div>
                            <div class="dashboard-summary-table-wrapper">
                                <div class="table-responsive dashboard-summary-table">
                                    <table class="table table-hover table-sm mb-0">
                                        <thead class="thead-light">
                                            <tr>
                                                <th>Categoría</th>
                                                <th class="text-right">Gastos</th>
                                                <th class="text-right">Monto</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="categoria in dashboard.por_categoria" :key="categoria.categoria">
                                                <td>{{ categoria.categoria }}</td>
                                                <td class="text-right">{{ categoria.cantidad }}</td>
                                                <td class="text-right font-weight-bold">{{ formatMonto(categoria.total_monto) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-7 mb-3">
                        <div class="card shadow-sm h-100">
                            <div class="card-header dashboard-card-header">
                                <i class="bx bx-table font-size-20 mr-2"></i>
                                <div>
                                    <h6 class="mb-0 font-weight-bold">Resumen por evento</h6>
                                    <small>Todos los eventos incluidos en el período</small>
                                </div>
                            </div>
                            <div class="dashboard-summary-table-wrapper">
                                <div class="table-responsive dashboard-summary-table">
                                    <table class="table table-hover table-sm mb-0">
                                        <thead class="thead-light">
                                            <tr>
                                                <th>Evento</th>
                                                <th>Coordinador</th>
                                                <th class="text-right">Gastos</th>
                                                <th class="text-right">Monto</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="evento in dashboard.por_evento" :key="evento.evento_id">
                                                <td>
                                                    <strong>{{ evento.codigo }}</strong>
                                                    <small v-if="evento.nombre" class="d-block text-muted">{{ evento.nombre }}</small>
                                                </td>
                                                <td>{{ evento.coordinador }}</td>
                                                <td class="text-right">{{ evento.cantidad }}</td>
                                                <td class="text-right font-weight-bold">{{ formatMonto(evento.total_monto) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Cargando resultados -->
            <div class="col-12" v-if="isLoading">
                <div class="text-center py-4 text-muted">
                    <b-spinner small class="mr-2" variant="primary"></b-spinner>
                    Actualizando resultados del período...
                </div>
            </div>

            <!-- Sin datos -->
            <div class="col-12" v-if="hasLoaded && !isLoading && dashboard.cantidad_gastos === 0">
                <div class="text-center py-5" style="border:1px dashed #dee2e6;border-radius:8px;background:#fff;">
                    <i class="bx bx-receipt font-size-48 d-block mb-2" style="color:#CB9700;"></i>
                    <p class="text-muted mb-0">No hay gastos registrados en este período</p>
                </div>
            </div>

            <!-- Sin resultados para el texto buscado -->
            <div class="col-12" v-if="hasLoaded && !isLoading && dashboard.cantidad_gastos > 0 && filteredData.length === 0">
                <div class="text-center py-4 text-muted" style="border:1px dashed #dee2e6;border-radius:8px;background:#fff;">
                    No hay eventos que coincidan con la búsqueda.
                </div>
            </div>

            <!-- Tabla resultados -->
            <div class="col-12" v-if="hasLoaded && !isLoading && filteredData.length > 0">
                <div class="card">
                    <div class="card-body">
                        <!-- Filtros -->
                        <div class="row align-items-center mb-3">
                            <div class="col-md-6">
                                <label class="d-inline-flex align-items-center mb-0" style="color:#252C5F;font-size:.85rem;">
                                    Mostrar&nbsp;
                                    <b-form-select v-model="perPage" size="sm" :options="pageOptions" class="mx-1"></b-form-select>&nbsp;registros
                                </label>
                            </div>
                            <div class="col-md-6 text-md-right">
                                <b-form-input v-model="filtro" type="search" placeholder="Buscar por código o coordinador..."
                                    class="form-control form-control-sm d-inline-block" style="max-width:260px;"></b-form-input>
                            </div>
                        </div>

                        <!-- Tabla principal -->
                        <div class="table-responsive">
                            <table class="table table-hover mb-0">
                                <thead style="background:#252C5F;color:#fff;">
                                    <tr>
                                        <th class="font-weight-normal py-2 pl-3" style="width:5%">Nº</th>
                                        <th class="font-weight-normal py-2" style="width:15%">Código Evento</th>
                                        <th class="font-weight-normal py-2" style="width:25%">Coordinador</th>
                                        <th class="font-weight-normal py-2" style="width:10%">Detalle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(item, index) in paginatedData">
                                        <tr :key="'row-'+(item.id || index)">
                                            <td class="pl-3">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
                                            <td><code>{{ item.codigo }}</code></td>
                                            <td>{{ item.coordinador_evento }}</td>
                                            <td>
                                                <button class="btn-ugm-white" v-b-toggle="'accordion-'+item.id" @click="ver_mas(item)" style="font-size:.8rem;padding:4px 12px;">
                                                    <i :class="item.boton === 'Ver menos' ? 'bx bx-chevron-up' : 'bx bx-chevron-down'" class="mr-1"></i>
                                                    {{ item.boton || 'Ver más' }}
                                                </button>
                                            </td>
                                        </tr>
                                        <tr :key="'collapse-'+(item.id || index)">
                                            <td colspan="4" class="p-0 border-0">
                                                <b-collapse :id="'accordion-'+item.id" accordion="my-accordion" role="tabpanel">
                                                    <div class="p-3" style="background:#f8f9fa;">
                                                        <div class="d-flex align-items-center mb-2">
                                                            <div style="width:4px;height:14px;background:#CB9700;border-radius:2px;margin-right:8px;"></div>
                                                            <span class="font-weight-bold" style="color:#252C5F;font-size:.85rem;">Gastos del evento</span>
                                                        </div>
                                                        <div class="table-responsive">
                                                            <table class="table table-sm bg-white mb-0" style="border-radius:6px;overflow:hidden;">
                                                                <thead style="background:#61B7E4;color:#fff;">
                                                                    <tr>
                                                                        <th class="font-weight-normal py-1 pl-3" style="width:5%">Nº</th>
                                                                        <th class="font-weight-normal py-1">Tipo Gasto</th>
                                                                        <th class="font-weight-normal py-1">Monto</th>
                                                                        <th class="font-weight-normal py-1">Fecha gasto</th>
                                                                        <th class="font-weight-normal py-1">Fecha descarga</th>
                                                                        <th class="font-weight-normal py-1">Comprobante</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item2, index2) in item.gastos" :key="index2">
                                                                        <td class="pl-3">{{ index2 + 1 }}</td>
                                                                        <td>{{ item2.tipo_gasto }}</td>
                                                                        <td>{{ item2.monto }}</td>
                                                                        <td>{{ formatFecha(item2.fecha) }}</td>
                                                                        <td>
                                                                            <span v-if="item2.fecha_descarga">{{ formatFecha(item2.fecha_descarga) }}</span>
                                                                            <span v-else class="text-muted" style="font-size:.8rem;">Sin descargar</span>
                                                                        </td>
                                                                        <td>
                                                                            <button class="btn-ugm-white mr-1" style="font-size:.75rem;padding:3px 10px;" @click="ver_comprobante(item2)">
                                                                                <i class="bx bx-file mr-1"></i> Ver
                                                                            </button>
                                                                            <button v-if="item2.fecha_descarga == null" class="btn-ugm-dark" style="font-size:.75rem;padding:3px 10px;" @click="generarPDF(item, item2)">
                                                                                <i class="bx bx-download mr-1"></i> PDF
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </b-collapse>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>

                        <!-- Paginación -->
                        <div class="row mt-3">
                            <div class="col text-right">
                                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" class="mb-0 justify-content-end"></b-pagination>
                            </div>
                        </div>

                        <b-modal ref="modal-imagen" title="Comprobante de Gasto" ok-only ok-title="Cerrar">
                            <pdf :src="direccion" v-if="extension=='pdf'"></pdf>
                            <img :src="direccion" width="100%" v-else>
                        </b-modal>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.dashboard-kpi {
    border-left: 4px solid;
}
.dashboard-kpi-icon {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.dashboard-card-header {
    display: flex;
    align-items: center;
    color: #252C5F;
    background: #f8f9fa;
    border-bottom: 1px solid #edf0f5;
}
.dashboard-card-header small {
    display: block;
    color: #7a8494;
    font-size: .72rem;
}
.dashboard-summary-table-wrapper {
    padding: 1rem;
}
.dashboard-summary-table {
    max-height: 355px;
    overflow: auto;
    border: 1px solid #e7ebf2;
    border-radius: 8px;
    background: #fff;
}
.dashboard-summary-table table {
    margin-bottom: 0;
}
.dashboard-summary-table th,
.dashboard-summary-table td {
    vertical-align: middle;
}
.btn-ugm-dark {
    background: #252C5F !important;
    color: #fff !important;
    border: 1px solid #252C5F !important;
    border-radius: 6px;
    padding: 7px 16px;
    font-size: .85rem;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-dark:hover { opacity: .85; }
.btn-ugm-gold {
    background: #CB9700 !important;
    color: #fff !important;
    border: 1px solid #CB9700 !important;
    border-radius: 6px;
    padding: 7px 16px;
    font-size: .85rem;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-gold:hover { opacity: .88; }
.btn-ugm-white {
    background: #fff !important;
    color: #252C5F !important;
    border: 1px solid #252C5F !important;
    border-radius: 6px;
    padding: 5px 10px;
    font-size: .8rem;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-white:hover { opacity: .8; }
</style>
</template>